<template>
    <v-dialog
        v-model="dialog"
        max-width="500"
        persistent
    >
        <v-card>
            <v-card-title class="bg-surface position-sticky top-0 z-index-1">
                <v-row justify="space-between" align="center">
                    <v-col cols="auto">
                        {{ title }}
                    </v-col>
                    <v-col v-if="closable" cols="auto">
                        <v-btn icon="mdi-close" variant="text" @click="handleCancel" />
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-subtitle>
                <slot name="subtitle">
                    {{ subtitle }}
                </slot>
            </v-card-subtitle>
            <v-card-text>
                <slot name="content">
                </slot>
            </v-card-text>

            <v-card-actions v-if="showActions" class="bg-surface position-sticky bottom-0 z-index-1">
                <slot name="actions">
                    <v-btn-secondary
                        v-if="cancelLabel"
                        :prepend-icon="cancelPrependIcon"
                        :text="cancelLabel"
                        :disabled="disableActions"
                        @click="handleCancel"
                    />
                    <v-btn-primary
                        :text="submitLabel"
                        :prepend-icon="submitPrependIcon"
                        :disabled="disableActions"
                        @click="handleSubmit"
                    />
                </slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
const EMITS = {
    CLOSE: 'close'
}
</script>

<script setup>
import { ref } from 'vue'

const emit = defineEmits(Object.values(EMITS))

const dialog = ref(false)

defineProps({
    title: {
        type: String,
        default: ''
    },
    subtitle: {
        type: String,
        default: ''
    },
    closable: {
        type: Boolean,
        default: true
    },
    submitPrependIcon: {
        type: String,
        default: 'mdi-check'
    },
    submitLabel: {
        type: String,
        default: 'Submit'
    },
    cancelLabel: {
        type: String,
        default: '' //disables cancel label since default cancel is per cross in top right corner (closable:true)
    },
    cancelPrependIcon: {
        type: String,
        default: 'mdi-close'
    },
    showActions: {
        type: Boolean,
        default: true
    },
    disableActions: {
        type: Boolean,
        default: false
    }
})

const handleSubmit = () => {
    emit(EMITS.CLOSE, true)
}

const handleCancel = () => {
    emit(EMITS.CLOSE, false)
    closeDialog()
}

const openDialog = () => {
    dialog.value = true
}

const closeDialog = () => {
    dialog.value = false
}


defineExpose({
    openDialog,
    closeDialog
})
</script>

<style scoped>
.z-index-1 {
    z-index: 1;
}
</style>